import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'
import SvgProcessingLoD from 'src/components/Svgs/SvgProcessingLoD'

import style from './Processing.style'

type ProcessingProps = {
  className?: string
  variant?: 'primary' | 'secondary' | 'severe'
} & ComponentProps<'svg'>

function Processing(props: ProcessingProps): ReactElement {
  const { className = '', variant = 'primary', ...rest } = props

  // TODO steph: replace with new design svg spinner
  // waiting on investigation to see how we want to handle adding svgs to the repo
  return (
    <SvgProcessingLoD
      className={cn('Processing', className, variant)}
      css={style}
      {...rest}
    />
  )
}

export default Processing
